<template>
  <div class="login">
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <el-upload
        class="avatar-uploader"
        action="https://jsonplaceholder.typicode.com/posts/"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="form.url" :src="form.url" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <el-form-item prop="username">
        <el-input
          v-model="form.username"
          prefix-icon="el-icon-user"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="form.password"
          show-password
          prefix-icon="el-icon-lock"
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitFn('ruleForm')">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { postLoginApi } from "@/api/login.js";

export default {
  data() {
    return {
      form: {
        url: require("@/assets/icons/user.png"),
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    // 绑定监听事件
    window.addEventListener("keydown", this.keyDown);
  },
  methods: {
    ...mapActions({
      setUserInfo: "login/FETCH_LOGIN",
      getMenuFn: "auth/FETCH_MENUS",
    }),
    keyDown(e) {
      if (e.keyCode === 13) {
        this.submitFn("ruleForm");
      }
    },
    submitFn(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await postLoginApi(this.form);
          if (res.code === 200) {
            // 设置用户信息
            this.setUserInfo({
              token: res.data.token,
              role: res.data.roleId,
              uname: res.data.nickname,
              userNum: res.data.userNum,
            });

            this.$message({
              showClose: true,
              duration: 700,
              message: res.msg,
              type: "success",
            });

            this.jumpFn("/");
          } else {
            this.$message.error(res.msg);
          }
          // this.setUserInfo({
          //     token: 'ahiohsdahwqdjioajdakdlmnkaqwdjaop',
          //     role: '4',
          //     uname: 'max科技园',
          //     userNum: '2023001',
          //   });
          //   this.jumpFn("/");
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
  destroyed() {
    // 销毁事件
    window.removeEventListener("keydown", this.keyDown, false);
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-form {
    width: 450px;
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f2f2f2;
    .el-image {
      width: 160px;
      height: 160px;
      border-radius: 50%;
      margin-bottom: 30px;
    }
    .el-input {
      width: 240px;
      height: 46px;
      font-size: 20px;
      ::v-deep .el-input__inner {
        height: 100%;
      }
    }
    .el-button {
      width: 240px;
      font-size: 20px;
      color: #fff;
      background-color: #068d6c;
    }
    .avatar-uploader {
      background-color: #fff;
      margin-bottom: 30px;
      border-radius: 50%;
      overflow: hidden;
    }
    .avatar-uploader .el-upload {
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }
}
</style>
